import { render, staticRenderFns } from "./TeaCase.vue?vue&type=template&id=ca99a7da&scoped=true&"
import script from "./TeaCase.vue?vue&type=script&lang=js&"
export * from "./TeaCase.vue?vue&type=script&lang=js&"
import style0 from "./TeaCase.vue?vue&type=style&index=0&id=ca99a7da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca99a7da",
  null
  
)

export default component.exports